import { CoursesService } from 'api/courses/service';
import { useCallback } from 'react';


export const useCourse = () => {
    const onGetAllCourse = useCallback(async () => {
        try {
            const response = await CoursesService.getInstance().findAll();

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOneCourse = useCallback(async (id: number) => {
        try {
            const response = await CoursesService.getInstance().findOne(id);

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllCourse, onGetOneCourse };
};
